export const replaceDomainWithLocalhost = (url: string) => {
    // Specify the old domain and the new localhost
    const domain = process.env.REACT_APP_APP_URL;
    const localDomain = 'http://localhost:3001';

    // check for environment (development or production)
    if (process.env.NODE_ENV === 'production') {
        return url;
    } else {
        // Replace the domain with localhost
        return url ? url.replace(domain, localDomain) : "";
    }
};
